import { Component, Input, ContentChild } from '@angular/core';
import { TranslationService } from '../../../../services/translation.service';
import { TcmTaxContentDirective } from './tcm-tax-content/tcm-tax-content.directive';

@Component({
    selector: 'tcm-tax-extension-wrapper',
    templateUrl: './tcm-tax-extension-wrapper.component.html',
    styleUrls: ['./tcm-tax-extension-wrapper.component.scss'],
    standalone: false
})
export class TcmTaxExtensionWrapperComponent {

  @Input() public label: string;
  @Input() public value: number;
  @Input() public taxRate: number;
  @Input() public isVisible: boolean;
  @Input() public showNet: boolean;
  @Input() public showRight: boolean;
  @Input() public showBottom: boolean;
  @Input() public showInTooltip: boolean = false;

  @ContentChild(TcmTaxContentDirective) public contentTpl: TcmTaxContentDirective;

  public get taxValue(): number {
    return this.showNet
      ? ((this.value) / (1 + this.taxRate))
      : (this.value * ( 1 + this.taxRate));
  }

  public get textValue(): string {
    if (this.label) {
      return this.label;
    }

    return this.showNet
      ? this.translationService.translate(x => x.Common.SearchColumnsAndDetailsFields.IncludeTaxNet)
      : this.translationService.translate(x => x.Common.SearchColumnsAndDetailsFields.IncludeTax);
  }

  constructor(private readonly translationService: TranslationService) { }

}
